import { render } from "./NotificationManagementView.vue?vue&type=template&id=16c0c244"
import script from "./NotificationManagementView.vue?vue&type=script&lang=js"
export * from "./NotificationManagementView.vue?vue&type=script&lang=js"

import "./NotificationManagementView.vue?vue&type=style&index=0&id=16c0c244&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__